var OVERLAY_ANIMATIONS = {
    NO_EFFECT: 'NO_EFFECT',
    FADE_IN: 'FADE_IN',
    EXPAND: 'EXPAND',
    SLIDE_UP: 'SLIDE_UP',
    SLIDE_RIGHT: 'SLIDE_RIGHT',
    SLIDE_DOWN: 'SLIDE_DOWN',
    SLIDE_LEFT: 'SLIDE_LEFT',
};
export default OVERLAY_ANIMATIONS;
//# sourceMappingURL=overlayAnimations.js.map